<div class="modal fade modalInfoComponent" [id]="modalId" tabindex="-1">

  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" (click)="onCancelAction()"></button>

        <div class="modal-img">
          <img [src]="icons[type]">
        </div>

        <p class="modal-question">{{ modalQuestion }}</p>

        <p class="modal-excerpt">{{ modalExcerpt }}</p>
      </div>

      <div class="modal-footer">
        <button *ngIf="cancelLabel" type="button" class="btn btn-light-cancel button-cancel" (click)="onCancelAction()">{{ cancelLabel }}</button>
        <button *ngIf="confirmLabel" type="button" class="btn btn-primary button-add"
          [ngClass]="{'btn-success': type === 'ok', 'btn-primary': type !== 'ok'}" (click)="onConfirmAction()">{{ confirmLabel }}</button>
      </div>
    </div>
  </div>

</div>
